import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, useTheme } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  uppercase: PropTypes.bool
};

export default function RHFTextField({ name, sx, uppercase, ...other }) {
  const { control } = useFormContext();
  const theme = useTheme();
  // The grey label is this component's own default. It used to be merged with
  // `{ ...sx }`, which silently THREW AWAY a caller's `sx` when that was a
  // function of the theme — the form of `sx` every Universe recipe takes
  // (DESIGN.md §28), so an auth or migrated field quietly rendered stock MUI.
  // The array form composes both and keeps the later rule winning, which is
  // exactly what the object spread did for object callers.
  const labelSx = {
    '& .MuiInputLabel-root': { color: theme.palette.labels.default }
  };
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          onChange={(event) =>
            field.onChange(
              uppercase ? event.target.value.toUpperCase() : event.target.value
            )
          }
          fullWidth
          error={!!error}
          helperText={error?.message}
          {...other}
          sx={typeof sx === 'function' ? [sx, labelSx] : { ...sx, ...labelSx }}
        />
      )}
    />
  );
}
